export function handleAiEditError(error: string, fallbackError: string) {
    if (error === 'too_much_characters') {
        return 'scheduler:scheduler_funnel.ai_caption.generation_error.too_much_characters';
    }
    if (error === 'too_much_hashtags') {
        return 'scheduler:scheduler_funnel.ai_caption.generation_error.too_much_hashtags';
    }
    if (error === 'ai_caption_too_much_characters') {
        return 'scheduler:scheduler_funnel.ai_caption.generation_error.ai_caption_too_much_characters';
    }
    if (error === 'ai_caption_too_much_hashtags') {
        return 'scheduler:scheduler_funnel.ai_caption.generation_error.ai_caption_too_much_hashtags';
    }
    return fallbackError;
}

export function getAiEditError(error: string, fallbackError: string) {
    if (error === 'too_much_characters') {
        return 'caption:ai_caption.generation_error.too_much_characters';
    }
    if (error === 'too_much_hashtags') {
        return 'caption:ai_caption.generation_error.too_much_hashtags';
    }
    if (error === 'ai_caption_too_much_characters') {
        return 'caption:ai_caption.generation_error.ai_caption_too_much_characters';
    }
    if (error === 'ai_caption_too_much_hashtags') {
        return 'caption:ai_caption.generation_error.ai_caption_too_much_hashtags';
    }
    return fallbackError;
}
